export enum Duration {
  Short = 300,
  Normal = 500,
  Long = 700,
}

export const transition = ({
  durationInMs = Duration.Normal,
  easing = "ease-in-out",
  props = [],
}: {
  props?: string[];
  durationInMs?: number;
  easing?: string;
} = {}): string => {
  return props.length
    ? props
        .map((propName) => `${propName} ${durationInMs}ms ${easing}`)
        .join(",")
    : `all ${durationInMs}ms ${easing}`;
};
